import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import MatieresService from "./MatieresService";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import Filarial from "../include/filarial";
import Joi from "joi-browser";

export default function MatieresIndex() {
    const activeLink = "MATIERES"

    const token = useSelector(state => state.auth.token)
    const [matieres, setMatieres] = useState([])
    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [errors, setErrors] = useState({});

    const [addFormData, setAddFormData] = useState({
        libelleMatiere: '',
        descriptionMatiere: '',
        coefficientMatiere: '',
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        libelleMatiere: '',
        descriptionMatiere: '',
        coefficientMatiere: '',
        id: ''
    });

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        libelleMatiere: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionMatiere: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        coefficientMatiere: Joi.number().min(1).max(10).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 2 caractères", max: "maximum 10" },
            },
        }).label("Coefficient"),
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        libelleMatiere: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionMatiere: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        coefficientMatiere: Joi.number().min(1).max(10).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 2 caractères", max: "maximum 10" },
            },
        }).label("Coefficient"),

        id: Joi.number().min(1).empty('').options({
            language: {
                number: { min: "minimum 1" },
            },
        }).label("Id")
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///



    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste matieres
    const fetchMatieres = async () => {
        await MatieresService.index(token).then((res) => {
            //console.log(res.data.data.matieres)
            setMatieres(res.data.data.matieres)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                MatieresService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchMatieres()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleMatiere: "",
            descriptionMatiere: "",
            coefficientMatiere: "",
        });
    };

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData({ ...editFormData, [name]: value });
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };



    //Enregistrer une matière
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await MatieresService.store(addFormData, token).then((response) => {
                //console.log(response.data.data)
                //Fermer le modal
                setIsVisible(false)
                if (response.data.status === 200) {
                    //Vider les champs du formulaire
                    clearForm()
                    //Actualiser la liste
                    fetchMatieres()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                //affichage des erreurs sur le formulaire
                //setValidationError(error.message)
            });
        }

    }

    ///Content du modal d'ajout de matière
    const addModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleSubmit}>
            <div className="row">
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleMatiere"
                        type="text"
                        value={addFormData.libelleMatiere}
                        onChange={handleChange}
                        placeholder="Exemple : FRANÇAIS"
                        required={true}
                        name="libelleMatiere"
                        style={{ "textTransform": "uppercase" }}
                    />

                    {errors.libelleMatiere && (
                        <div className="alert alert-danger">
                            {errors.libelleMatiere}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Coefficient <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control className="form-control" id="bs-validation-coefficientMatiere"
                        type="number"
                        value={addFormData.coefficientMatiere}
                        onChange={handleChange}
                        required={true}
                        name="coefficientMatiere"
                    />

                    {errors.coefficientMatiere && (
                        <div className="alert alert-danger">
                            {errors.coefficientMatiere}
                        </div>
                    )}

                </div>
            </div>

            <div className=" mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionMatiere" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionMatiere"
                    onChange={handleChange}
                    name="descriptionMatiere"
                    rows="3"
                    value={addFormData.descriptionMatiere}
                ></textarea>

                {errors.descriptionMatiere && (
                    <div className="alert alert-danger">
                        {errors.descriptionMatiere}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );


    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await MatieresService.show(id, token).then((response) => {
            const data = response.data.data;
            setEditFormData({
                libelleMatiere: data.libelleMatiere,
                descriptionMatiere: data.descriptionMatiere,
                coefficientMatiere: data.coefficientMatiere,
                id: id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //update fonction
    const handleUpdate = async (event) => {
        event.preventDefault()
        //console.log("okay")
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await MatieresService.update(editFormData, token).then((response) => {
                //Fermer le modal
                setEditModal(false)

                if (response.data.status !== 200) {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });

                } else {
                    fetchMatieres()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                //Fermer le modal
                setEditModal(false)

                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
            });

        }
    };


    ///Content du modal d'edition de matière
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleMatiere"
                        type="text"
                        value={editFormData.libelleMatiere}
                        onChange={handleEditChange}
                        placeholder="Exemple : FRANÇAIS"
                        required={true}
                        name="libelleMatiere"
                        style={{ "textTransform": "uppercase" }}
                    />

                    {errors.libelleMatiere && (
                        <div className="alert alert-danger">
                            {errors.libelleMatiere}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Coefficient <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control className="form-control" id="bs-validation-coefficientMatiere"
                        type="number"
                        value={editFormData.coefficientMatiere}
                        onChange={handleEditChange}
                        required={true}
                        maxLength={10}
                        minLength={1}
                        name="coefficientMatiere"
                    />

                    {errors.coefficientMatiere && (
                        <div className="alert alert-danger">
                            {errors.coefficientMatiere}
                        </div>
                    )}

                </div>
            </div>

            <div className=" mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionMatiere" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionMatiere"
                    onChange={handleEditChange}
                    name="descriptionMatiere"
                    rows="3"
                    value={editFormData.descriptionMatiere}
                ></textarea>

                {errors.descriptionMatiere && (
                    <div className="alert alert-danger">
                        {errors.descriptionMatiere}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );



    useEffect(() => {
        fetchMatieres();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-2">
                    <h5 className="card-header">Liste des matieres &nbsp; &nbsp; &nbsp;  <Button variant="primary" onClick={() => setIsVisible(true)}>
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une matière
                    </Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Libelle </th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Coefficient Matiere</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {matieres.length > 0 && matieres.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.libelleMatiere}
                                        </td>
                                        <td className="cell">{item.descriptionMatiere}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.coefficientMatiere}</span></td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>

            {/* Modal Ajout des matieres*/}
            <CustomAddModal
                modalTitle="Enregistrement matière"
                modalContent={addModalContent}
                visible={isVisible}
                close={() => setIsVisible(false)}
            />

            {/**End Modal Ajout des matieres*/}

            {/* Modal Edition des matieres*/}
            <CustomEditModal
                modalTitle="Modification matière"
                modalContent={editModalContent}
                visible={editModal}
                close={() => setEditModal(false)}
            />

            {/**End Modal Edition des matieres*/}

        </Layout>
    )
}